"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshSession = refreshSession;

var _sessionActionKeys = _interopRequireDefault(require("./sessionActionKeys"));

function refreshSession() {
  return {
    type: _sessionActionKeys.default.REFRESH_SESSION
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/session/sessionActions.js
// module id = 4344
// module chunks = 25